import React from "react";

import Modal from "../common/Modal";
import StarRatingInput from "./StarRatingInput";
import ProductReviewOwnerFields from "./ProductReviewOwnerFields";
import styles from "../../styles/pages/product/ProductDetailsPage.module.css";

const ProductReviewFormModal = ({
  isOpen,
  reviewForm,
  formConfig = null,
  onClose,
  onChange,
  onSubmit,
}) => {
  if (!isOpen) return null;

  const update = (patch) => onChange({ ...reviewForm, ...patch });

  return (
    <Modal onClose={onClose}>
      <div className={styles.reviewForm}>
        <h4 className={styles.formTitle}>Write Your Review</h4>
        <div className={styles.ratingInput}>
          <label>Rating:</label>
          <StarRatingInput
            rating={reviewForm.rating}
            onChange={(star) => update({ rating: star })}
          />
        </div>

        <ProductReviewOwnerFields
          formConfig={formConfig}
          values={reviewForm}
          onChange={onChange}
        />

        <div className={styles.commentInput}>
          <label htmlFor="reviewComment">Your Review:</label>
          <textarea
            id="reviewComment"
            value={reviewForm.comment}
            onChange={(e) => update({ comment: e.target.value })}
            placeholder="Share your experience with this product..."
            rows={5}
          />
        </div>
        <button className={styles.submitReviewBtn} onClick={onSubmit} type="button">
          Submit Review
        </button>
      </div>
    </Modal>
  );
};

export default ProductReviewFormModal;
